import { render } from "./tutorialtip.vue?vue&type=template&id=67d97930&scoped=true"
import script from "./tutorialtip.vue?vue&type=script&lang=js"
export * from "./tutorialtip.vue?vue&type=script&lang=js"

import "./tutorialtip.vue?vue&type=style&index=0&id=67d97930&scoped=true&lang=less"

import exportComponent from "D:\\Septris Remake\\septris-remake\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d97930"]])

export default __exports__